class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/device-inventory`;
    }
    /**
     * Adds an existing phone (customer provided device - BYOD) as an unassigned device to the account inventory.
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/device-inventory
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */
    async post(addDeviceToInventoryRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), addDeviceToInventoryRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes an existing unassigned (without digital line or phone number) device or multiple devices
     * from the account inventory. It is possible to delete up to 10 devices per request.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/device-inventory
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */
    async delete(deleteDeviceFromInventoryRequest, restRequestConfig) {
        const r = await this.rc.delete(this.path(), deleteDeviceFromInventoryRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
